<template>
  <div class="goods-wrapper">
    <van-tabs
      id="goods-tabs"
      class="tabs"
      :ellipsis="false"
      v-model="active"
      :border="false"
      @change="onChange"
    >
      <van-tab
        :title="item.title"
        v-for="(item, index) in columnConfig"
        :key="index"
      >
        <div class="goods-list" v-if="goodsList.length">
          <div v-for="(sku, index) in goodsList" :key="index">
            <div class="sku-item" v-show="!isHide || (isHide && index < 4) " @click="goodsTap(sku)">
              <div class="sku-img">
                <!-- <img v-lazy="skuImg(sku.pic_url)" /> -->
                <img v-lazy="sku.pic_url" />
                <div class="goods-tag" v-if="titleConfig && titleConfig.img"
                  :style="{
                    background: `url(${titleConfig.img})`,
                    backgroundSize: '100% auto',
                    backgroundRepeat: 'no-repeat'
                  }"
                ></div>
              </div>
              <div class="sku-intro">
                <div class="sku-name van-ellipsis">{{sku.name}}</div>
                <div class="tags">
                  <div class="tag" v-if="titleConfig && titleConfig.subtitle">{{ titleConfig.subtitle }}</div>
                  <div class="tag">已售{{ sku.sales }}</div>
                </div>
                <div class="price">
                  <div class="sku-price">
                    <div class="discount-price">
                      <span class="sale-price">¥{{sku.activity | salePrice(sku.equity, sku.market_price)}}</span>
                    </div>
                    <div class="sheng" v-show="discountPrice(sku.activity,sku.equity,sku.market_price)">
                      <discount-price :sku="sku" />
                    </div>
                  </div>
                  <button class="add-cart-btn" @click.stop="addCart(sku)"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="load-more-wrapper">
          <div class="load-more" v-if="!finished && goodsList.length >= 4" @click="loadMore">
            <span>点击查看更多</span>
            <i class="icon"></i>
          </div>
          <div class="load-more" v-if="finished && isHide && goodsList.length > 4" @click="toggleList">
            <span>点击展开</span>
            <i class="icon"></i>
          </div>
          <div class="prompt" v-if="(finished && !isHide) || goodsList.length < 4">没有更多了</div>
          <div class="load-more" v-if="finished && !isHide && goodsList.length > 4" @click="toggleList">
            <span>点击收起</span>
            <i class="icon icon-arrow-up"></i>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import DiscountPrice from '@/components/DiscountPrice'
import api from '@/utils/api'
import Big from 'big.js'
const init = new Big(0)
let flag = false
export default {
  name: 'goods-column',
  props: {
    titleConfig: {
      type: Object
    },
    columnConfig: {
      type: Array
    }
  },
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    DiscountPrice
  },
  data () {
    return {
      loading: false,
      isHide: false,
      active: 0,
      total: 0,
      currentColumn: 0,
      goodsList: [],
      finished: false,
      pageNum: 1
    }
  },
  filters: {
    // 价格展示
    salePrice (activity, member, market) {
      if (activity) {
        return activity.discount
      } else if (member) {
        return member.discount
      } else {
        return market
      }
    }
  },
  computed: {
    discountPrice () {
      return (ap, mp, np) => {
        if (ap && ap.discount) {
          const dif = init.plus(np).minus(ap.discount).toFixed(2)
          return dif > 0 ? dif : 0
        } else if (mp && mp.discount) {
          const dif = init.plus(np).minus(mp.discount).toFixed(2)
          return dif > 0 ? dif : 0
        } else {
          return false
        }
      }
    },
    skuImg () {
      return (img) => {
        if (img.includes('?')) {
          return `${img}&x-oss-process=image/resize,w_350`
        } else {
          return `${img}?x-oss-process=image/resize,w_350`
        }
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async goodsTap (sku) {
      if (flag) {
        return false
      }
      flag = true
      const goodsid = sku.item_id
      const skuid = sku.sku_id
      const platform = sku.platform
      const type = sku.item_type
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    },
    async addCart (item) {
      const res = await this.$axios.post('/api/cart/2.0/add', {
        id: item.sku_id,
        num: item.lowest_buy
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('加入购物车成功')
          return true
        } else if (code === -1) {
          return false
        } else {
          this.$toast(msg)
          return false
        }
      }
    },
    onChange (index) {
      this.active = index
      this.initData()
    },
    initData () {
      this.isHide = false
      this.finished = false
      this.goodsList = []
      this.pageNum = 1
      this.fetchList()
    },
    loadMore () {
      this.pageNum += 1
      this.fetchList()
    },
    toggleList () {
      this.isHide = !this.isHide
      if (this.isHide) {
        location.href = `#goods-tabs`
      }
    },
    async fetchList () {
      this.$toast.loading('加载中....')
      const res = await this.$axios.get(
        `/api/goods/channelItemsFirst/${this.columnConfig[this.active].column}/${this.pageNum}/9${this.pageNum === 1 ? '/4' : ''}`
      )
      this.$toast.clear()
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          if (this.pageNum > 1 && data.length < 10) {
            this.finished = true
          } else if (this.pageNum === 1 && data.length < 4) {
            this.finished = false
          }
          this.goodsList = [...this.goodsList, ...data]
        } else if (code === 9006) {
          this.finished = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goods-wrapper {
  background: #fff;
  /deep/ .van-tabs__wrap{
    padding: 0 .3rem;
  }
  /deep/ .van-tab--active{
    font-size: .32rem !important;
    font-weight: 500 !important;
    flex: none !important;
  }
  /deep/ .van-tabs--line .van-tabs__wrap{
    height: 40px;
  }
  .goods-list{
    padding: 0 .24rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #f5f5f5;
  }
  .load-more-wrapper{
    background: #f5f5f5;
    padding: .2rem;
  }
  .prompt{
    color: #999;
    text-align: center;
    font-size: .25rem;
    margin-bottom: .2rem;
  }
  .load-more{
    width: 2.26rem;
    height: .6rem;
    color: #747474;
    background: #FFFFFF;
    border-radius: .3rem;
    margin: 0 auto;
    font-size: .24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      margin-right: .1rem;
    }
    .icon{
      width: .22rem;
      height: .22rem;
      background: url('../../../assets/img/icon-arrow.png') no-repeat;
      background-size: 100% 100%;
      display: inline-block;
      margin-top: .04rem;
    }
    .icon-arrow-up{
      transform: rotate(180deg);
    }
  }
}
.sku-item {
  margin-top: 0.2rem;
  width: 3.42rem;
  background-color: #fff;
  border-radius: 0.08rem;
  overflow: hidden;
  .sku-img {
    width: 3.42rem;
    height: 3.42rem;
    position: relative;
    .goods-tag {
      width: .51rem;
      height: .54rem;
      position: absolute;
      top: 0;
      left: .32rem;
    }
  }
  .tags{
    display: flex;
    align-items: center;
    .tag{
      margin-right: .1rem;
      height: .38rem;
      color: #D59865;
      line-height: .3rem;
      font-size: .22rem;
      padding: .03rem .08rem .03rem;
      background: #FFF2E7;
      border-radius: .08rem;
      border: 1px solid #D59865;
      box-sizing: border-box;
    }
  }
  .sku-intro {
    padding: 0.1rem 0.16rem 0.2rem;
    .sku-name {
      margin: 0.1rem 0 0.2rem;
      color: #28292C;
      font-size: @fz26;
    }
    .price{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: .04rem;
      margin-top: .04rem;
      height: .76rem;
    }
    .discount-price {
      display: flex;
      align-items: center;
      font-size: @fz32;
      color: #ff5555;
      .sale-price {
        min-width: 1.3rem;
        padding-right: 0.1rem;
      }
    }
    .sku-price{
      flex: 1;
    }
    .sheng{
      margin-top: .1rem;
    }
    .add-cart-btn{
      display: block;
      width: .52rem;
      height: .52rem;
      background: url(../imgs/icon-add.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
